module.exports = __webpack_public_path__ + "img/TCC-L9-Pagina7 A_2.cb8812c6.png";